import React from 'react';
import { StarRating } from './StarRating';

export const CourseCard = ({ course }) => {
    const fallbackImage = 'https://images.unsplash.com/photo-1513258496099-48168024aec0?w=500&h=280&fit=crop';
    
    return (
        <div className="bg-white border h-100 overflow-hidden">
            <img 
                src={course.image || fallbackImage} 
                alt={course.title} 
                className="img-fluid w-100 object-fit-cover" 
                style={{ height: "170px" }} 
                onError={(e) => { e.target.src = fallbackImage; }}
            />
            <div className="item-info small">
                <div className="flex-grow-1 p-3">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                        <span className={`course-category badge bg-${course.categoryColor} bg-opacity-10 fw-medium rounded-0 text-${course.categoryColor} text-uppercase`}>
                            {course.category}
                        </span>
                        <span className="course-price text-base fw-semibold text-primary">{course.price}</span>
                    </div>
                    <div className="course-title fw-medium text-gray-900 text-truncate-2">{course.title}</div>
                </div>
                <div className="border-top d-flex flex-wrap align-items-center justify-content-between gap-2 text-gray-700 fw-medium px-3 py-2">
                    <span className="ratings d-flex align-items-center gap-1">
                        <StarRating rating={course.rating} />
                        <span className="rating-number">{course.rating.toFixed(1)}</span>
                    </span>
                    <span>{course.students} <span className="fw-normal text-gray-500">students</span></span>
                </div>
            </div>
        </div>
    )
}
